<template>
  <div class="community-comment-thread">
    <form class="comment-form d-flex" @submit.prevent="submit">
      <input
        v-model="text"
        class="form-control comment-input"
        placeholder="Escreva um comentário..."
      />
      <button
        class="btn btn-primary ml-2"
        type="submit"
        :disabled="loading || !text.trim()"
      >
        <loading :show="loading" small>Enviar</loading>
      </button>
    </form>

    <div v-if="loadingList" class="text-center py-3">
      <b-spinner variant="primary" small />
    </div>

    <div v-else class="comment-list mt-3">
      <comment-item
        v-for="comment in comments"
        :key="comment.id"
        :comment="comment"
        :post-id="postId"
        @changed="reload"
      />

      <button v-if="hasMore" class="btn btn-link load-more" @click="loadMore">
        Carregar mais comentários
      </button>

      <div v-if="!comments.length" class="empty text-center py-3">
        Seja o primeiro a comentar.
      </div>
    </div>
  </div>
</template>

<script>
const LIMIT = 10;

export default {
  name: "CommentThread",
  components: {
    CommentItem: () => import("./CommentItem.vue")
  },
  props: {
    postId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      comments: [],
      count: 0,
      offset: 0,
      text: "",
      loading: false,
      loadingList: true
    };
  },
  computed: {
    hasMore() {
      return this.comments.length < this.count;
    }
  },
  mounted() {
    this.fetch(true);
  },
  methods: {
    fetch(reset = false) {
      if (reset) {
        this.offset = 0;
        this.loadingList = true;
      }
      return this.$store
        .dispatch("community/listComments", {
          postId: this.postId,
          limit: LIMIT,
          offset: this.offset
        })
        .then(data => {
          this.count = data.count;
          this.comments = reset
            ? data.results
            : [...this.comments, ...data.results];
          this.$emit("count-change", this.count);
        })
        .finally(() => {
          this.loadingList = false;
        });
    },
    loadMore() {
      this.offset += LIMIT;
      this.fetch(false);
    },
    reload() {
      this.fetch(true);
    },
    submit() {
      if (!this.text.trim()) return;
      this.loading = true;
      this.$store
        .dispatch("community/comment", {
          postId: this.postId,
          text: this.text.trim()
        })
        .then(() => {
          this.text = "";
          this.reload();
        })
        .catch(error => {
          const message =
            error?.response?.data?.non_field_errors?.[0] ||
            "Não foi possível comentar";
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-comment-thread {
  .comment-input {
    min-height: 44px;
    border-radius: 10px;
  }

  .load-more {
    padding: 0;
    font-size: 13px;
  }

  .empty {
    font-size: 13px;
    opacity: 0.7;
  }
}
</style>
